export class ApiObjAdminPhoneNumberSource {
    
    // ========================================================================
    // === Constants
    // ========================================================================

    static readonly SOURCE_TYPE_1_BASE = 1;
    static readonly SOURCE_TYPE_2_OPTIONAL = 2;
    static readonly SOURCE_TYPE_3_OPTIONAL_PREMIUM = 3;

    // ========================================================================
    // === Fields
    // ========================================================================

    id: number;
    name: string;
    prio: number;
    sort_order: number;
    source_type: number
    is_disabled: boolean;
    is_enabled_for_user: boolean;

    // ========================================================================
    // === Create
    // ========================================================================
    
    constructor(data: any) {
        this.id = parseInt(data.id);
        this.name = data.name;
        this.prio = parseInt(data.prio);
        this.sort_order = parseInt(data.sort_order);
        this.source_type = parseInt(data.source_type);
        this.is_disabled = parseInt(data.is_disabled) === 1;
        this.is_enabled_for_user = parseInt(data.is_enabled_for_user) === 1;
    }
}
